import { render, staticRenderFns } from "./topicListDetails.vue?vue&type=template&id=a8eb4a1c&scoped=true"
import script from "./topicListDetails.vue?vue&type=script&lang=js"
export * from "./topicListDetails.vue?vue&type=script&lang=js"
import style0 from "./topicListDetails.vue?vue&type=style&index=0&id=a8eb4a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eb4a1c",
  null
  
)

export default component.exports